import { micromark } from "micromark";

/**
 * Converts stored Markdown to HTML that is safe to inline.
 *
 * micromark is CommonMark-compliant and secure by default: raw HTML in the
 * source is escaped (allowDangerousHtml is off) and link/image URLs with
 * dangerous protocols such as javascript: are dropped. Do not enable
 * allowDangerousHtml or allowDangerousProtocol here.
 */
export function renderMarkdown(markdown: string | undefined): string {
  if (!markdown?.trim()) return "";
  return micromark(markdown);
}
